export default "__VITE_ASSET__UrWfAVkm__"